export const ON_LOAD_EVENTS = {
    ISCOMPANY_AVAILABLE: "ISCOMPANY_AVAILABLE",
    PRIVACY_POLICY: "PRIVACY_POLICY",
    GET_COUNTRY_LIST: "GET_COUNTRY_LIST",
    INVITE_PARTICIPANT: "INVITE_PARTICIPANT",
    ADD_SESSION_STATS: "ADD_SESSION_STATS",
};

export const NOT_RESET_EVENTS_ON_ENDCALL = {
    IS_ROOM_PARTICIPANT_EXCEED: "IS_ROOM_PARTICIPANT_EXCEED",
};

export const IS_ROOM_PARTICIPANT_EXCEED = {
    SUCCESS: "IS_ROOM_PARTICIPANT_EXCEED__SUCCESS",
};

export const ISCOMPANY_AVAILABLE = {
    START: "ISCOMPANY_AVAILABLE__START",
    SUCCESS: "ISCOMPANY_AVAILABLE__SUCCESS",
    ERROR: "ISCOMPANY_AVAILABLE__ERROR",
};

export const PRIVACY_POLICY = {
    START: "PRIVACY_POLICY_START",
    SUCCESS: "PRIVACY_POLICY_SUCCESS",
    ERROR: "PRIVACY_POLICY_ERROR",
};

export const GET_COUNTRY_LIST = {
    START: "GET_COUNTRY_LIST_START",
    SUCCESS: "GET_COUNTRY_LIST_SUCCESS",
    ERROR: "GET_COUNTRY_LIST_ERROR",
};

export const INVITE_PARTICIPANT = {
    START: "INVITE_PARTICIPANT_START",
    SUCCESS: "INVITE_PARTICIPANT_SUCCESS",
    ERROR: "INVITE_PARTICIPANT_ERROR",
    RESET: "INVITE_PARTICIPANT_RESET",
};

export const ADD_SESSION_STATS = {
    START: "ADD_SESSION_STATS_START",
    SUCCESS: "ADD_SESSION_STATS_SUCCESS",
    ERROR: "ADD_SESSION_STATS_ERROR",
    RESET: "ADD_SESSION_STATS_RESET",
};

const defaultIsCompanyAvailableState = {
    isCompanyAvailableError: false,
    isCompanyAvailableData: false,
    isCompanyAvailableLoading: false,
};

const defaultGetPrivacyPolicyState = {
    privacyPolicyError: false,
    privacyPolicyData: false,
    privacyPolicyLoading: false,
};

const defaultGetCountryListState = {
    getCountryListError: false,
    getCountryListData: false,
    getCountryListLoading: false,
};

const defaultInviteParticipantState = {
    inviteParticipantError: false,
    inviteParticipantData: false,
    inviteParticipantLoading: false,
};

const defaultAddSessionState = {
    addSessionStatsError: false,
    addSessionStatsData: false,
    addSessionStatsLoading: false,
};

const defaultIsRoomParticipantExceedState = {
    isRoomParticipantExceed: false,
};

const defaultState = {
    ...defaultIsCompanyAvailableState,
    ...defaultGetPrivacyPolicyState,
    ...defaultGetCountryListState,
    ...defaultInviteParticipantState,
    ...defaultAddSessionState,
    ...defaultIsRoomParticipantExceedState,
};

const onLoadFunctionReducer = (state = defaultState, action = {}) => {
    switch (action.event) {
        case ON_LOAD_EVENTS.ISCOMPANY_AVAILABLE:
            return {
                ...state,
                isCompanyAvailableLoading: action.type === ISCOMPANY_AVAILABLE.START,
                isCompanyAvailableData: action.type === ISCOMPANY_AVAILABLE.SUCCESS ? action.payload : false,
                isCompanyAvailableError: action.type === ISCOMPANY_AVAILABLE.ERROR ? action.payload : false,
            };
        case ON_LOAD_EVENTS.PRIVACY_POLICY:
            return {
                ...state,
                privacyPolicyLoading: action.type === PRIVACY_POLICY.START,
                privacyPolicyData: action.type === PRIVACY_POLICY.SUCCESS ? action.payload : false,
                privacyPolicyError: action.type === PRIVACY_POLICY.ERROR ? action.payload : false,
            };
        case ON_LOAD_EVENTS.GET_COUNTRY_LIST:
            return {
                ...state,
                getCountryListLoading: action.type === GET_COUNTRY_LIST.START,
                getCountryListData: action.type === GET_COUNTRY_LIST.SUCCESS ? action.payload : false,
                getCountryListError: action.type === GET_COUNTRY_LIST.ERROR ? action.payload : false,
            };
        case ON_LOAD_EVENTS.ADD_SESSION_STATS:
            return {
                ...state,
                addSessionStatsLoading: action.type === ADD_SESSION_STATS.START,
                addSessionStatsData: action.type === ADD_SESSION_STATS.SUCCESS ? action.payload : false,
                addSessionStatsError: action.type === ADD_SESSION_STATS.ERROR ? action.payload : false,
            };
        case ON_LOAD_EVENTS.INVITE_PARTICIPANT:
            if (action.type === INVITE_PARTICIPANT.RESET) {
                return {
                    ...state,
                    ...defaultInviteParticipantState,
                };
            } else {
                return {
                    ...state,
                    inviteParticipantLoading: action.type === INVITE_PARTICIPANT.START,
                    inviteParticipantData: action.type === INVITE_PARTICIPANT.SUCCESS ? action.payload : false,
                    inviteParticipantError: action.type === INVITE_PARTICIPANT.ERROR ? action.payload : false,
                };
            }
        case NOT_RESET_EVENTS_ON_ENDCALL.IS_ROOM_PARTICIPANT_EXCEED:
            return {
                ...state,
                isRoomParticipantExceed: action.payload,
            };
        default:
            return state;
    }
};

export default onLoadFunctionReducer;
